/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The V1QualityDefinitionBody model module.
 * @module model/V1QualityDefinitionBody
 * @version v0
 */
export default class V1QualityDefinitionBody {
  /**
   * Constructs a new <code>V1QualityDefinitionBody</code>.
   * @alias module:model/V1QualityDefinitionBody
   * @class
   * @param file {Blob} 
   */
  constructor(file) {
    this.file = file;
  }

  /**
   * Constructs a <code>V1QualityDefinitionBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/V1QualityDefinitionBody} obj Optional instance to populate.
   * @return {module:model/V1QualityDefinitionBody} The populated <code>V1QualityDefinitionBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new V1QualityDefinitionBody();
      if (data.hasOwnProperty('file'))
        obj.file = ApiClient.convertToType(data['file'], 'Blob');
    }
    return obj;
  }
}

/**
 * @member {Blob} file
 */
V1QualityDefinitionBody.prototype.file = undefined;

